import { useContext } from 'react';
import { UploadContext } from './provider';
export const useUploadUsers = () => useContext(UploadContext);
